import { Box } from "@mui/material";
import { useStore } from "@priolo/jon";
import { FunctionComponent } from "react";
import dialogSo from "stores/cycle/editDialog";
import CropLotCmp from "./CropLotCmp";
import CropLotEditDialog from "./Dialog";



const CropLotsTab: FunctionComponent = () => {

    // STORE
    const dialogSa = useStore(dialogSo)

    // HOOKs

    // RENDER
    return <>
        <Box sx={{ display: "flex", flexDirection: "column", gap: "10px" }}>
            {dialogSa.cycle?.cropLots?.map(cropLot =>
                <CropLotCmp key={cropLot.id} cropLot={cropLot} />
            )}
        </Box>

        <CropLotEditDialog />
    </>
}

export default CropLotsTab
